import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HttpRequestClient } from './http-request-client';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [],
  providers: [HttpRequestClient],
})
export class HttpModule {}
